var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 127,
    viewBox: "0 0 129 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9943 64.5473C27.5394 65.3195 30.6264 65.0373 34.6639 63.8715L34.6773 63.8638C34.8521 63.7629 35.0425 63.7098 35.2321 63.7019C39.0787 62.5418 43.7337 60.6192 48.7122 58.0825C48.8006 57.9717 48.9109 57.8781 49.0386 57.8044C49.2044 57.7087 49.3809 57.6575 49.5599 57.6468C51.1446 56.8216 52.7626 55.9352 54.3935 54.9936C56.7481 53.6342 58.9837 52.2448 61.0686 50.8529C64.7706 48.3869 67.9974 45.9203 70.5492 43.6402C70.6501 43.4475 70.8059 43.2829 71.0075 43.1664C71.0523 43.1406 71.0984 43.117 71.1449 43.0991C75.0119 39.5427 77.1668 36.4819 76.8368 34.6376C74.9691 33.7049 70.8494 34.3145 65.5163 36.1595C60.7532 37.8069 55.0214 40.4409 49.0674 43.8335C48.8568 43.9551 48.6485 44.0754 48.4379 44.197C43.5787 47.0025 39.2169 49.9451 35.6572 52.7353C29.3526 57.6781 25.5661 62.15 25.9956 64.5495L25.9943 64.5473Z",
    fill: "#F8F5E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0046 52.3567C33.9804 52.3767 33.9583 52.3954 33.9327 52.4132C27.3781 57.6317 23.9004 61.6296 25.1438 63.7833C25.2201 63.9155 25.3131 64.0351 25.4262 64.1431C25.5178 64.2397 25.6273 64.3258 25.7467 64.4033C25.8095 64.4448 25.878 64.4859 25.9475 64.5234C25.9629 64.5295 25.9774 64.539 25.9941 64.5473C27.5392 65.3196 30.6262 65.0373 34.6637 63.8716C34.8506 63.8175 35.0396 63.7621 35.2319 63.7019C39.0785 62.5418 43.7335 60.6192 48.7121 58.0825C48.9931 57.9382 49.2742 57.7938 49.5598 57.6469C51.1444 56.8216 52.7624 55.9353 54.3933 54.9937C56.7479 53.6343 58.9836 52.2449 61.0684 50.853C64.7704 48.3869 67.9972 45.9203 70.549 43.6403C70.7513 43.4577 70.9491 43.2778 71.1447 43.0992C75.0118 39.5428 77.1666 36.482 76.8366 34.6376C76.8019 34.4276 76.7324 34.2346 76.6302 34.0576C75.5601 32.2043 72.3647 31.9934 66.1702 34.0847",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3819 42.8496L47.1937 42.9582C42.5301 45.6627 39.1183 48.0778 35.6698 50.7709C35.6267 50.8048 35.5813 50.84 35.5381 50.8738",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6711 34.9301C59.3297 36.5163 55.0221 38.8389 49.7118 41.7943",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8357 35.1429C63.8357 35.1429 63.8171 35.1475 63.7998 35.1545",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7646 35.1659C63.7646 35.1659 63.7737 35.1606 63.8005 35.1543",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5013 64.9591C40.1434 63.9052 43.7251 62.2138 48.5603 59.7807C48.6064 59.7571 48.6547 59.7322 48.7031 59.7072",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7288 35.4792C77.7168 35.4533 77.7012 35.4264 77.687 35.4017C77.6236 35.2919 77.5455 35.1876 77.4587 35.0943C77.3384 34.9635 77.197 34.8479 77.031 34.7466C76.9695 34.7074 76.9049 34.673 76.8367 34.6377C74.969 33.705 70.8493 34.3146 65.5162 36.1596C60.7531 37.807 55.0213 40.441 49.0673 43.8337C48.8567 43.9552 48.6484 44.0755 48.4378 44.1971C43.5786 47.0026 39.2168 49.9452 35.6571 52.7354C29.3525 57.6782 25.566 62.1502 25.9955 64.5496C25.9913 64.558 25.993 64.566 25.9969 64.5727C26.0321 64.7735 26.1013 64.9606 26.1997 65.1309C26.4817 65.6195 26.9155 65.9517 27.5225 66.1391C28.8442 66.5503 30.9743 66.2767 34.0983 65.4531",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6645 43.7814C72.6821 43.7652 72.7019 43.7478 72.7182 43.7295C76.453 40.2285 78.3432 37.5476 77.8655 35.8303C77.8329 35.7117 77.7891 35.5996 77.7314 35.4894",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0411 51.4293C66.2885 49.2466 68.6626 47.5383 70.9629 45.5469C71.039 45.482 71.1173 45.4159 71.1921 45.3488C71.2537 45.2953 71.3132 45.243 71.3749 45.1895",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.978 58.9914C52.6654 58.1218 53.7092 57.3428 55.4477 56.3391C57.623 55.0832 59.1695 54.1246 61.1104 52.8456C61.1261 52.8366 61.1382 52.8266 61.1539 52.8175",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6942 82.5656C99.5854 80.3054 100.627 78.2758 100.605 76.6541",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4761 91.5428C90.9831 89.0907 93.8684 86.6898 96.0836 84.3441",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1412 92.475C86.7999 92.0379 86.8554 91.9789 87.476 91.543",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2517 100.494C74.5926 99.3906 76.4629 98.3616 78.8981 96.9556C80.9569 95.7669 82.2357 95.1571 84.0306 93.9924",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.724 102.068C69.3117 101.818 69.2826 101.835 69.8817 101.564",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2136 105.332C59.2376 105.328 59.2617 105.323 59.2844 105.315C62.2767 104.673 64.9442 103.679 68.7242 102.068",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8101 105.084C49.8101 105.084 49.8185 105.088 49.822 105.089C51.5216 105.886 54.0003 106.418 57.5463 105.673C57.5681 105.67 57.5886 105.664 57.6104 105.66",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6737 102.122C50.3412 102.925 53.1315 103.163 56.6223 102.774C57.3189 102.697 58.0417 102.593 58.792 102.465C62.1176 101.893 65.9287 100.816 69.9327 99.1884C70.4734 98.9659 71.0217 98.736 71.5693 98.4945C73.7159 97.551 75.9041 96.452 78.0906 95.1896C79.9165 94.1354 81.6482 93.0579 83.2784 91.9703C83.4992 91.8249 83.7164 91.6786 83.9314 91.5335C84.2298 91.3313 84.5248 91.1282 84.8162 90.9241C88.6194 88.2712 91.7951 85.592 94.1691 83.0919C94.7161 82.5131 95.2244 81.9448 95.6858 81.3885C98.3722 78.1463 99.5323 75.3132 98.7518 73.3973C98.7002 73.2717 98.6419 73.15 98.5746 73.0334",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0759 72.3564C98.8128 73.162 99.5025 73.8185 100.242 74.4733C100.286 74.5135 100.315 74.542 100.326 74.5564C100.336 74.5743 100.329 74.5782 100.308 74.5667C100.165 74.5266 99.4582 74.0832 99.057 73.8696L98.7503 73.3952L98.0746 72.3541L98.0759 72.3564Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7287 35.479C77.7287 35.479 77.73 35.4813 77.7316 35.4893C77.744 35.521 77.7904 35.6376 77.8657 35.8302C79.0746 38.9122 88.137 61.4898 98.0758 72.3562",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7156 64.2928C25.7156 64.2928 25.7968 64.3714 25.9474 64.5235C25.9645 64.5375 25.9793 64.5529 25.9954 64.5704C26.2962 64.8689 26.822 65.402 27.5211 66.1368C32.5971 71.4831 46.7596 87.5335 48.6481 102.125C48.6993 102.513 48.7425 102.904 48.775 103.291",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8235 34.8986C63.8477 35.0131 63.8929 35.1275 63.955 35.235C64.2474 35.7415 64.8491 35.9559 65.3832 35.779C65.4582 35.7536 65.5337 35.719 65.6054 35.6776C66.1521 35.362 66.3582 34.6842 66.0973 34.1237C66.0792 34.0923 66.0655 34.0583 66.0474 34.027C65.7136 33.4488 64.9812 33.277 64.4032 33.6107C63.9327 33.8823 63.7102 34.4023 63.8235 34.8986Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1937 42.9582C47.2191 43.0332 47.2537 43.1088 47.2951 43.1805C47.629 43.7587 48.3676 43.9568 48.9456 43.6231C49.5236 43.2893 49.7214 42.5506 49.3876 41.9725C49.0538 41.3943 48.3138 41.194 47.7358 41.5277C47.2295 41.82 47.0167 42.424 47.1937 42.9582Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4447 50.6288C35.0973 50.4618 34.6757 50.4662 34.3172 50.6731C33.7392 51.0068 33.5415 51.7455 33.8753 52.3237C33.8934 52.3551 33.9102 52.3842 33.9328 52.413C34.2868 52.9228 34.9791 53.0819 35.5257 52.7663C35.5616 52.7456 35.5961 52.7226 35.6307 52.6997C36.1261 52.3419 36.2808 51.658 35.9677 51.1157C35.8888 50.979 35.7856 50.8623 35.6699 50.7706C35.5981 50.7135 35.5234 50.667 35.4447 50.6288Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4258 64.1431C25.145 64.0035 24.8007 64.0021 24.5095 64.1702C24.048 64.4367 23.8877 65.0282 24.1555 65.4921C24.4234 65.956 25.0145 66.1107 25.476 65.8443C25.9375 65.5778 26.0978 64.9863 25.8313 64.5246C25.8067 64.482 25.7763 64.4398 25.7463 64.4033C25.6572 64.2904 25.5477 64.2042 25.4258 64.1431Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4588 35.0942C77.7263 35.2057 78.041 35.1973 78.3144 35.0395C78.7759 34.773 78.9339 34.1828 78.6674 33.7211C78.4008 33.2595 77.8093 33.099 77.3478 33.3654C76.8863 33.6319 76.7261 34.2234 76.9939 34.6873C77.0055 34.7075 77.0172 34.7276 77.0311 34.7465C77.1393 34.9081 77.29 35.0243 77.4588 35.0942Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5491 43.6404C70.3537 43.9952 70.3458 44.442 70.5632 44.8185C70.7094 45.0717 70.9336 45.2531 71.192 45.3489C71.518 45.4685 71.8924 45.4495 72.2172 45.262C72.4524 45.1262 72.6267 44.921 72.7229 44.6891C72.8508 44.3882 72.8566 44.0412 72.7184 43.7295C72.7009 43.6889 72.6812 43.6495 72.6579 43.6091C72.3499 43.0758 71.6976 42.8667 71.1448 43.0992C71.0983 43.1171 71.0522 43.1407 71.0074 43.1666C70.8058 43.283 70.65 43.4477 70.5491 43.6404Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0738 50.8619C60.5783 51.2196 60.4236 51.9036 60.7367 52.4459C60.8325 52.6117 60.9611 52.7466 61.1108 52.8455C61.1604 52.8796 61.2144 52.9111 61.2704 52.9356C61.6151 53.0981 62.0323 53.0963 62.3885 52.8907C62.7447 52.685 62.9402 52.351 62.9808 51.9869C63.0004 51.8501 62.9921 51.7115 62.9619 51.5765C62.9364 51.4598 62.8913 51.3454 62.8291 51.2378C62.4953 50.6596 61.7567 50.4616 61.1787 50.7953C61.1429 50.816 61.1083 50.8389 61.0738 50.8619Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M48.712 58.0824C48.3973 58.4583 48.3363 59.0045 48.5963 59.4549C48.6403 59.5311 48.692 59.5999 48.7468 59.6639C49.1229 60.0772 49.7463 60.1895 50.2481 59.8997C50.5371 59.7329 50.7306 59.4628 50.8101 59.1659C50.83 59.0916 50.8428 59.0155 50.8485 58.9375C50.8658 58.7035 50.8143 58.4643 50.6888 58.2469C50.4507 57.8345 50.004 57.6144 49.5597 57.6468C49.3807 57.6575 49.2041 57.7086 49.0383 57.8044C48.9106 57.8781 48.8003 57.9716 48.712 58.0824Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2353 65.5145C34.3711 65.7498 34.5763 65.9242 34.8082 66.0204C35.1461 66.166 35.543 66.155 35.8857 65.9571C36.1591 65.7993 36.3491 65.5491 36.4355 65.2692C36.4658 65.1769 36.4821 65.0809 36.4877 64.982",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4874 64.982C36.4874 64.982 36.4877 64.9669 36.4883 64.9576C36.4981 64.7367 36.4464 64.5126 36.3274 64.3065C36.0945 63.9031 35.6664 63.6841 35.2316 63.702C35.042 63.7099 34.8517 63.763 34.6769 63.8639L34.6635 63.8717C34.1319 64.1875 33.9296 64.8512 34.1773 65.4044C34.1958 65.4415 34.2142 65.4787 34.2349 65.5145",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M100.309 74.5689C99.8829 74.9434 99.7645 75.5765 100.058 76.0852C100.194 76.3205 100.399 76.4949 100.631 76.5911C100.969 76.7366 101.366 76.7256 101.709 76.5277C102.287 76.194 102.485 75.4553 102.151 74.8771C101.817 74.2989 101.078 74.1009 100.5 74.4346C100.438 74.4708 100.377 74.5115 100.326 74.5564C100.319 74.5602 100.312 74.5641 100.308 74.5667L100.309 74.5689Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1601 84.2493C95.9052 84.1544 95.681 83.9731 95.5348 83.7198C95.201 83.1417 95.3988 82.403 95.9768 82.0692C96.1202 81.9865 96.2759 81.9354 96.4324 81.9168C96.8984 81.8599 97.3775 82.0793 97.6272 82.5118C97.6402 82.5342 97.6531 82.5566 97.6638 82.5803C97.9459 83.1465 97.7421 83.8438 97.1866 84.1646C96.8617 84.3522 96.4851 84.3724 96.1601 84.2493Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M84.151 93.9228C84.0988 93.8633 84.0506 93.7955 84.0092 93.7237C83.6961 93.1814 83.8509 92.4975 84.3463 92.1397C84.3821 92.119 84.4154 92.0938 84.4512 92.0731C85.0247 91.742 85.7573 91.9346 86.0952 92.5045L86.1017 92.5157C86.4355 93.0939 86.239 93.8348 85.661 94.1685C85.1547 94.4608 84.5252 94.3432 84.151 93.9228Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9551 101.282C69.6213 100.704 69.8191 99.9655 70.3971 99.6317C70.9751 99.298 71.7137 99.4961 72.0475 100.074C72.1265 100.211 72.1746 100.356 72.1961 100.502C72.2676 100.978 72.0469 101.47 71.6055 101.725C71.0791 102.029 70.4171 101.891 70.053 101.426C70.0178 101.381 69.9849 101.334 69.9551 101.282Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2024 105.295C56.8685 104.717 57.0651 103.976 57.6431 103.642C58.2211 103.309 58.961 103.509 59.2948 104.087C59.5225 104.482 59.5032 104.95 59.2841 105.315C59.1819 105.485 59.0365 105.632 58.8528 105.738C58.4294 105.982 57.9193 105.942 57.5462 105.673C57.4094 105.576 57.2916 105.45 57.2024 105.295Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8222 105.089C49.726 105.321 49.5527 105.523 49.3197 105.657C48.7417 105.991 48.0031 105.793 47.6693 105.215C47.3354 104.636 47.5333 103.898 48.1113 103.564C48.3286 103.439 48.5677 103.387 48.7995 103.406C49.186 103.434 49.5534 103.646 49.7617 104.007C49.97 104.367 49.9711 104.752 49.8222 105.089Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7228 44.689C72.7228 44.689 83.8325 73.6892 95.6857 81.3887C95.92 81.5462 96.1581 81.6896 96.3959 81.8272",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9267 45.4481C70.9267 45.4481 70.9403 45.4821 70.9627 45.5468C71.671 47.4357 82.5176 76.0321 94.1689 83.0921C94.2532 83.145 94.3398 83.1966 94.425 83.246",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9843 51.9878C62.9843 51.9878 75.5856 80.9485 84.816 90.9241C84.894 91.0076 84.9721 91.091 85.0488 91.1722",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1868 52.7448C61.1868 52.7448 61.215 52.8091 61.2702 52.9357C62.3799 55.4683 74.3401 82.4804 83.2514 91.9292",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3882 59.5753C48.3882 59.5753 48.4469 59.6459 48.5605 59.7806C50.6665 62.3057 71.4522 87.5721 69.9326 99.1885C69.9205 99.2761 69.9093 99.3603 69.8937 99.447C69.8818 99.5196 69.87 99.5922 69.8568 99.6625",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9642 59.2055C50.9642 59.2055 73.5211 86.3238 71.5689 98.4948L71.5323 98.6952",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8079 66.0202C34.8079 66.0202 56.9793 83.6858 56.6219 102.774C56.6198 102.796 56.6199 102.817 56.62 102.838",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6034 65.2649C36.6034 65.2649 59.757 82.5934 58.792 102.465C58.7888 102.548 58.7844 102.628 58.78 102.708",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5743 87.3706C34.5743 87.3706 38.4263 90.1725 37.1884 94.7956",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0312 89.3275C34.0312 89.3275 35.9148 91.6224 35.3839 93.6053",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7266 55.4538C93.7266 55.4538 95.9666 60.301 98.6101 61.0098",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6444 54.9055C95.6444 54.9055 96.4631 57.2237 98.2195 57.8859",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M94.024 19.5511L58.1133 18.4175C58.1133 18.4175 54.6075 14.7614 52.1445 18.2302C49.6829 21.7012 57.7193 19.67 57.7193 19.67L93.6307 21.4515C93.6307 21.4515 95.9315 21.2407 94.024 19.5511Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7681 67.887L22.862 38.9969C22.862 38.9969 21.975 36.5448 25.4837 35.3737C28.996 34.2035 24.0337 39.5724 24.0337 39.5724L13.8984 69.0416C13.8984 69.0416 12.1433 70.1924 11.7681 67.887Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3288 107.49C76.3288 107.49 73.1491 109.717 69.6816 109.511",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M73.654 110.591C73.654 110.591 71.0262 111.839 69.4339 111.497",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrum);
export default __webpack_public_path__ + "static/media/drum.981aac436dfaf8c3affdd77547607a02.svg";
export { ForwardRef as ReactComponent };